function imageCarouselFlickityInit() {
    const keyFeatures = document.querySelector('#marquee-section-container');
    if (!keyFeatures) return;

    const speedLevel = parseInt(keyFeatures.getAttribute('data-speed')) || 5;

    const minSpeed = 0.1;
    const maxSpeed = 2.5;
    const marqueeSpeed =
    minSpeed + ((speedLevel - 1) / 9) * (maxSpeed - minSpeed);
  
    const slides = Array.from(keyFeatures.children);
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('is-clone');
      keyFeatures.appendChild(clone);
    });
  
    const flickityInstance = new Flickity(keyFeatures, {
      cellAlign: 'left',
      contain: false,
      draggable: true,
      freeScroll: true,
      wrapAround: false, 
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false,
      selectedAttraction: 0.01,
      friction: 0.15,
      setGallerySize: false, 
      adaptiveHeight: true
    });
  
    let requestId;
  
    function play() {
      
      flickityInstance.x -= marqueeSpeed;
      flickityInstance.settle(flickityInstance.x);
      requestId = requestAnimationFrame(play);
  
      const totalWidth = flickityInstance.slideableWidth;
      if (Math.abs(flickityInstance.x) >= totalWidth / 2) {
        flickityInstance.x = 0;
      }
    }
  
    function pause() {
      if (requestId) {
        cancelAnimationFrame(requestId);
        requestId = undefined;
      }
    }
  
    play();
  
    // Step 4: Pause on hover
    keyFeatures.addEventListener('mouseenter', pause);
    keyFeatures.addEventListener('mouseleave', play);
  }
  
  imageCarouselFlickityInit();
